export default {
  recapTitle: {
    id: 'search_recap_title',
    defaultMessage: 'Your search:',
  },
  allProductsTitle: {
    id: 'landing_all_products_title',
    defaultMessage: 'All products',
  },
  filterSortLabel: {
    id: 'product_filter_sort_label',
    defaultMessage: 'Sort by',
  },
  landingNavigationSeoTitle: {
    id: 'landing_navigation_seo_title',
    defaultMessage: 'Categories',
  },
  months: {
    id: 'landing_months',
    defaultMessage: 'months',
  },
  totalProduct: {
    id: 'landing_page_filters_products_new_plural',
    defaultMessage: `{total, plural,
      one {# product}
      other {# products}
    }`,
  },
  filter: {
    id: 'landing_page_filter',
    defaultMessage: 'Filter',
  },
  sort: {
    id: 'landing_page_sort',
    defaultMessage: 'Sort',
  },
  vanishingDealSubtitle: {
    id: 'vanishing_deals_landing_pickle_portrait_subtitle',
    defaultMessage: 'The artist of the deal',
  },
  vanishingDealTitle: {
    id: 'vanishing_deals_landing_pickle_portrait_title',
    defaultMessage: 'Curated by Mr Pickles',
  },
}
